import fileDownload from 'js-file-download';
import { toast } from 'react-toastify';
import { requestAxios } from 'services';
import { performanceGetFactory, performanceResumeGetFactory } from 'factories';
import { PerformanceReport, PerformanceReportResume } from 'types';
import { formatTimestamp } from 'helpers';

interface GetPerformanceResumeParams {
  startDate: number;
  endDate: number;
  store: string | null;
}

interface GetPerformanceParams extends GetPerformanceResumeParams {
  currentPage: string;
  pageSize: string;
}

async function getReport(
  params: GetPerformanceParams
): Promise<PerformanceReport> {
  let result: any;

  try {
    const response = await requestAxios.get('reports/performance/report', {
      params,
    });

    result = response.data;
  } catch (error) {
    console.error(error);
  }

  return performanceGetFactory(result);
}

async function getResume(
  params: GetPerformanceResumeParams
): Promise<PerformanceReportResume> {
  let result: any;

  try {
    const response = await requestAxios.get('v2/reports/performance/resume', {
      params,
    });

    result = response.data;
  } catch (error) {
    console.error(error);
  }

  return performanceResumeGetFactory(result);
}

async function exportToExcel(
  params: GetPerformanceResumeParams
): Promise<void> {
  return requestAxios
    .get('reports/performance/export', {
      params,
      responseType: 'blob',
    })
    .then((response) => {
      function formatDate(date: number) {
        const formattedDate = formatTimestamp(date).formattedDate;

        return formattedDate.replaceAll('/', '');
      }

      const { startDate, endDate } = params;
      const formattedStartDate = formatDate(startDate);
      const formattedEndDate = formatDate(endDate);
      const fileName = `${formattedStartDate}_${formattedEndDate}_performance.csv`;

      fileDownload(response.data, fileName);
    })
    .catch((reason) => {
      console.error(reason);

      toast.error('Não foi possível baixar o arquivo', {
        autoClose: false,
        hideProgressBar: false,
      });
    });
}

export const reportsPerformanceService = {
  getReport,
  getResume,
  exportToExcel,
};
